'use client';

export async function apiGetMe() {
  const res = await fetch('/api/auth/me', { method: 'GET' });
  const data = await res.json().catch(() => null);
  if (!data) throw new Error('Invalid server response');
  return data;
}

export async function apiRegister(payload) {
  const res = await fetch('/api/auth/register', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  const data = await res.json().catch(() => null);
  if (!res.ok) throw new Error(data?.error || 'Register failed');
  return data;
}

export async function apiLogin(payload) {
  const res = await fetch('/api/auth/login', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  const data = await res.json().catch(() => null);
  if (!res.ok) throw new Error(data?.error || 'Login failed');
  return data;
}

export async function apiLogout() {
  const res = await fetch('/api/auth/logout', { method: 'POST' });
  const data = await res.json().catch(() => null);
  if (!res.ok) throw new Error(data?.error || 'Logout failed');
  return data;
}

export function startGoogleOAuth(mode) {
  const m = mode === 'register' ? 'register' : 'login';
  window.location.href = `/api/auth/google/start?mode=${encodeURIComponent(m)}`;
}

export async function apiGetGooglePending(token) {
  const res = await fetch(`/api/auth/google/pending?token=${encodeURIComponent(token)}`);
  const data = await res.json().catch(() => null);
  if (!res.ok) throw new Error(data?.error || 'Failed to load Google signup info');
  return data;
}

export async function apiCompleteGoogleSignup(payload) {
  const res = await fetch('/api/auth/google/complete', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  const data = await res.json().catch(() => null);
  if (!res.ok) throw new Error(data?.error || 'Google signup failed');
  return data;
}

export async function apiUpdateProfile(payload) {
  const res = await fetch('/api/account/profile', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  const data = await res.json().catch(() => null);
  if (!res.ok) throw new Error(data?.error || 'Profile update failed');
  return data;
}

export async function apiChangeUsername(payload) {
  const res = await fetch('/api/account/username', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  const data = await res.json().catch(() => null);
  if (!res.ok) throw new Error(data?.error || 'Username change failed');
  return data;
}

export async function apiUploadAvatar(file) {
  const form = new FormData();
  form.append('file', file);

  const res = await fetch('/api/account/avatar', {
    method: 'POST',
    body: form,
  });
  const data = await res.json().catch(() => null);
  if (!res.ok) throw new Error(data?.error || 'Avatar upload failed');
  return data;
}
